import classNames from "classnames";
import { Link } from "react-router-dom";

interface OffcanvasMenuBoxItemProps {
  onClick?: (e: React.MouseEvent) => void;
  active?: boolean;
  className?: string;
  title: string;
  link: string;
  icon?: string;
  isDouble?: boolean;
}

export default function OffcanvasMenuBoxItem({
  onClick,
  active = false,
  className,
  title,
  link,
  icon,
  isDouble = false,
}: OffcanvasMenuBoxItemProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Link
      to={link}
      onClick={handleClick}
      className={`border-solid border-b border-neutral-200 text-center w-full ${className}`}
    >
      <div
        className={`flex flex-col items-center justify-center 
          ${isDouble ? "py-7 px-6" : "py-7 px-6"} 
          lg:py-4 lg:px-4`} 
      >
        {icon && (
          <span
            className={classNames({
              "material-symbols-outlined mb-4 flex justify-center": true,
              "text-4xl": true,
              "text-neutral-400": !active,
              "text-blue-600": active,
              "lg:text-3xl": true, // Riduce la dimensione delle icone su desktop
            })}
            translate="no"
          >
            {icon}
          </span>
        )}
        <span
          className={classNames({
            "text-base": isDouble,
            "text-neutral-500": !active,
            "text-blue-600": active,
            "lg:text-sm": true, // Riduce la dimensione del testo su desktop
          })}
        >
          {title}
        </span>
      </div>
    </Link>
  );
}
